import { createNamespacedHelpers } from 'vuex'
import * as API from 'src/api/dev/services'
import * as T from './types'

const {
    mapState,
    mapActions,
    mapGetters,
    mapMutations
} = createNamespacedHelpers('services')

const module = {
    namespaced: true,

    state: {
        groups: []
    },
    mutations: {
        [T.SET_GROUP_LIST](state, payload) {
            const { group } = payload
            state.groups = group
        }
    },

    actions: {
        // 业务对象详情
        [T.GET_SERVICE_DETAIL](store, { webappId, objectId }) {
            return API.getServiceDetail(webappId, objectId)
        },

        // 刷新业务对象详情
        [T.REFRESH_SERVICE_DETAIL](store, { webappId, objectId }) {
            return API.refreshServiceDetail(webappId, objectId)
        },

        // 获取分组列表
        [T.GET_GROUP_LIST]({ commit }, payload) {
            return API.getGroupList(payload).then(res => {
                commit(T.SET_GROUP_LIST, res)
                return res
            })
        },

        // 获取单个分组下服务列表
        [T.GET_SERVICE_LIST](store, payload) {
            return API.getServiceList(payload)
        },
        [T.CREATE_GROUP](store, payload) {
            return API.createGroup(payload)
        },
        [T.EDIT_GROUP](store, payload) {
            return API.editGroup(payload)
        },
        [T.DELETE_GROUP](store, payload) {
            return API.deleteGroup(payload)
        },

        [T.ADD_SERVICE](store, payload) {
            return API.addService(payload)
        },
        [T.EDIT_SERVICE](store, payload) {
            return API.editService(payload)
        },
        [T.DELETE_SERVICE](store, payload) {
            return API.deleteService(payload)
        },
        [T.DATA_COMPONENT]() {
            return API.getDataComponent()
        }
    }
}

export { mapState, mapActions, mapGetters, mapMutations }

export default module
